import React from 'react';
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { 
    PANTALLA_PORTADA_ID, PANTALLA_LIBRO_ID, PANTALLA_VENTANA_ID, PANTALLA_INDICE_ID,
    configureStore, 
    actions,
    Ibook,
    PantallaVentana
} from 'ibook-api'

import { 
    PantallaPortada, 
    PantallaIndice, 
    PantallaLibro, 
    PantallaGameGenerator, 
    PantallaGameGeneratorSeleccionarFlashcards,
    PantallaSeleccionarFlashcards,

    PantallaIndiceFlipped
} from './pantallas'

// configuracion
const store = configureStore()

// pantallas
store.dispatch(actions.addPantalla(PANTALLA_PORTADA_ID, PantallaPortada ))
store.dispatch(actions.addPantalla(PANTALLA_INDICE_ID, PantallaIndice ))
store.dispatch(actions.addPantalla('pantalla-indice-flipped', PantallaIndiceFlipped ))
store.dispatch(actions.addPantalla(PANTALLA_LIBRO_ID, PantallaLibro ))
store.dispatch(actions.addPantalla(PANTALLA_VENTANA_ID, PantallaVentana ))
store.dispatch(actions.addPantalla('pantalla-game-generator', PantallaGameGenerator ))
store.dispatch(actions.addPantalla('pantalla-game-generator-seleccionar-flashcards', PantallaGameGeneratorSeleccionarFlashcards ))
store.dispatch(actions.addPantalla('pantalla-seleccionar-flashcards', PantallaSeleccionarFlashcards ))

// leer configuracion y lanzar la pantalla inicial
const irAPantallaInicial = actions.pantalla(PANTALLA_PORTADA_ID, {}) 
store.dispatch( actions.loadConfig( irAPantallaInicial ))

ReactDOM.render(<Provider store={store}><Ibook /></Provider>, document.getElementById('root'))
// registerServiceWorker();

